import './LiveAds.css';

const NoLiveAds = () => {
  return (
    <div className="LiveadsImage">
      <img src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/Web_Campaign.png" alt="loader" />
      <p className='NoAdsPara'>Your ads are under review. You can view them here once it is approved.</p>
    </div>
  );
}

export default NoLiveAds;